<script setup>
import { ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { usePaymentElement } from "@/composables/usePaymentElement";

defineProps({
  showNotice: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const emit = defineEmits(['ready', 'change', 'error']);

const paymentElementRef = ref(null);

const {
  createPaymentElement,
  mountPaymentElement,
  clientSecret
} = usePaymentElement();

const paymentElement = ref(null);

const setupPaymentElement = async () => {
  const element = await createPaymentElement();

  mountPaymentElement(paymentElementRef.value);

  element.value.on('ready', () => {
    emit('ready');
  });

  element.value.on('change', (event) => {
    if (event.error) {
      emit('error', event.error);
    }

    emit('change', event);
  });

  paymentElement.value = element;
  return element;
};

useQuery({
  queryKey: ['paymentElement', clientSecret],
  queryFn: setupPaymentElement,
  enabled: () => !!clientSecret.value && !!paymentElementRef.value,
  retry: 1,
  staleTime: Infinity,
});
</script>

<template>
  <div>
    <div
      ref="paymentElementRef"
      class="tw-p-4 tw-min-h-[40px] tw-md:p-3"
    />

    <p
      v-if="showNotice"
      class="tw-mt-3 tw-text-sm tw-text-neutral-700"
    >
      <em><strong>Please note,</strong> this payment method will also be used for future payments.</em>
    </p>
  </div>
</template>
